import React from "react";
import { Grid } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { CustomButton } from "../../../../common/components";
import UserDrawer from "../user-drawer/UserDrawer";
import FormEditProfile from "../form/FormEditProfile";
import style from "./UserBanner.module.css";
import { useApi } from "../../../../common/hooks";
import { LicenceManagementService } from "../../../../api";
import { setUpdateLicenceManagement, setResetEditUserLicenceManagement } from "../../../../common/slice";
import { translate } from "../../../../common/providers";

export default function UserBanner() {
	const dispatch = useDispatch();
	const licenceManagementStore = useSelector(({ context }) => context.licenceManagement);
	const [openDrawer, setOpenDrawer] = React.useState(false);
	const [children, setChildren] = React.useState();
	const [title, setTitle] = React.useState("");
	const [selectedAction, setSelectedAction] = React.useState("");
	const { call: switchBlockedUser } = useApi(LicenceManagementService.switchBlockedUser);
	const { call: getListUsers } = useApi(LicenceManagementService.getListUsers);
	const { call: updateProfile } = useApi(LicenceManagementService.updateProfile);

	const handelOpenDrawer = () => {
		setOpenDrawer(true);
	};
	const handelCloseDrawer = () => {
		setOpenDrawer(false);
	};
	const getChildren = (action) => {
		if (action === "edit-profil") {
			return <FormEditProfile user={licenceManagementStore?.userSelect} />;
		}
		return <Grid>-</Grid>;
	};

	const refreshList = () => {
		const params = {
			page: licenceManagementStore.page,
			limit: licenceManagementStore.rowsPerPage,
			payload: {
				sort: licenceManagementStore.sort,
				username: licenceManagementStore.search?.searchUserName,
				direction: licenceManagementStore.direction,
			},
		};
		getListUsers(params)
			.then((data) => {
				dispatch(
					setUpdateLicenceManagement({
						listUsers: data,
						selectedUser: data.contents.find(
							(item) => item.id === licenceManagementStore?.selectedUser?.id
						),
					})
				);
			})
			.catch((e) => {
				console.error(e);
			});
	};
	const submitBlocked = () => {
		handelCloseDrawer();
	};
	const submitEditUser = () => {
		if (licenceManagementStore.editUser.role) {
			updateProfile({
				userId: licenceManagementStore?.selectedUser?.id,
				payload: { value: licenceManagementStore.editUser.role },
			})
				.then(() => {
					refreshList();
					dispatch(setResetEditUserLicenceManagement());
					handelCloseDrawer();
				})
				.catch(console.error);
		}
		handelCloseDrawer();
	};
	const actionBanner = () => {
		switch (selectedAction) {
			case "edit-profil":
				return submitEditUser();
			case "blocked-user":
				return submitBlocked();
			default:
				return null;
		}
	};
	const handelSelectAction = (action) => {
		setSelectedAction(action);
		setChildren(getChildren(action));
		handelOpenDrawer();
		setTitle(licenceManagementStore?.selectedUser?.displayName);
	};

	const handelSwitchBockedUser = () => {
		switchBlockedUser({ userId: licenceManagementStore?.selectedUser?.id }).then(() => {
			refreshList();
		});
	};

	return (
		<div className={style.BannerContainer}>
			<div className={style.BannerItems}>
				<div className={style.BannerTitle}>{translate("common:licence-management.title.username")}</div>

				<div data-testid={`user.banner.${licenceManagementStore?.selectedUser?.displayName}`}>
					{licenceManagementStore?.selectedUser?.displayName}
				</div>
			</div>
			<div className={style.BannerItems}>
				<div className={style.BannerTitle}>{translate("common:licence-management.title.profile")}</div>

				<div>{licenceManagementStore?.selectedUser?.profil}</div>
			</div>
			<div className={style.BannerActions}>
				<CustomButton color="secondary" variant="outlined" onClick={handelSwitchBockedUser}>
					{licenceManagementStore?.selectedUser?.userStatus === "ACTIVE"
						? translate("common:licence-management.user.btn-blocked")
						: translate("common:licence-management.user.btn-unblocked")}
				</CustomButton>

				<CustomButton color="secondary" variant="outlined" onClick={() => handelSelectAction("edit-profil")}>
					{translate("license-management.users.edit-profile.button")}
				</CustomButton>
			</div>

			<UserDrawer
				childrens={children}
				closeDrawer={handelCloseDrawer}
				onclick={actionBanner}
				open={openDrawer}
				title={title}
			/>
		</div>
	);
}
